"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldShowEligibilityFlowSelector = exports.hasMarketingContactsWriteScopeSelector = exports.marketingContactsOnRenewalSelector = exports.isInMCBetaSelector = exports.isUngatedForMonthlyMarkingSelector = exports.isUngatedForMCGlobalLaunchSelector = void 0;

var _Scopes = _interopRequireDefault(require("pricing-pages-unified-ui/constants/Scopes"));

var _ScopeSelectors = require("pricing-pages-unified-ui/selectors/ScopeSelectors");

var _ConfigSelectors = require("pricing-pages-unified-ui/selectors/ConfigSelectors");

var _CountrySelectors = require("pricing-pages-unified-ui/selectors/CountrySelectors");

var _PublicFeatureFlagSelectors = require("pricing-pages-unified-ui/selectors/PublicFeatureFlagSelectors");

var _PublicFeatureFlags = require("pricing-pages-unified-ui/constants/PublicFeatureFlags");

var _GatingSelectors = require("pricing-pages-unified-ui/selectors/GatingSelectors");

var _Gates = require("pricing-pages-unified-ui/constants/Gates");

var _RequestStatusTypes = _interopRequireDefault(require("pricing-pages-unified-ui/constants/RequestStatusTypes"));

var isUngatedForMCGlobalLaunchSelector = function isUngatedForMCGlobalLaunchSelector(state) {
  if ((0, _ConfigSelectors.isAppAuthSelector)(state)) {
    return (0, _GatingSelectors.isUngatedSelector)(state, _Gates.MARKETING_CONTACTS_GLOBAL_LAUNCH);
  }

  return (0, _PublicFeatureFlagSelectors.publicFeatureFlagSelector)(state, _PublicFeatureFlags.CBX_MARKETING_CONTACTS_LAUNCH);
};

exports.isUngatedForMCGlobalLaunchSelector = isUngatedForMCGlobalLaunchSelector;

var isUngatedForMonthlyMarkingSelector = function isUngatedForMonthlyMarkingSelector(state) {
  if ((0, _ConfigSelectors.isAppAuthSelector)(state)) {
    return (0, _GatingSelectors.isUngatedSelector)(state, _Gates.MARKETING_CONTACTS_MONTHLY_MARKING);
  }

  return (0, _PublicFeatureFlagSelectors.publicFeatureFlagSelector)(state, _PublicFeatureFlags.CBX_MARKETING_CONTACTS_MONTHLY_EVALUATION);
};

exports.isUngatedForMonthlyMarkingSelector = isUngatedForMonthlyMarkingSelector;

var isInMCBetaSelector = function isInMCBetaSelector(state) {
  var override = localStorage.getItem('CBX:MarketingContactsBeta');

  if (['true', 'false'].includes(override)) {
    return override === 'true';
  }

  if (isUngatedForMCGlobalLaunchSelector(state)) {
    return true;
  } // In-app pricing page


  if ((0, _ConfigSelectors.isAppAuthSelector)(state)) {
    var marketingContacts = state.marketingContacts;
    if (!marketingContacts) return false;
    return marketingContacts.isInMCBeta;
  } // Public pricing page


  var publicFlagEnabled = (0, _PublicFeatureFlagSelectors.publicFeatureFlagSelector)(state, _PublicFeatureFlags.CBX_JUNE_2_LAUNCH);
  var isInANZ = (0, _CountrySelectors.isInANZSelector)(state);
  return publicFlagEnabled && isInANZ;
};

exports.isInMCBetaSelector = isInMCBetaSelector;

var marketingContactsOnRenewalSelector = function marketingContactsOnRenewalSelector(state) {
  var marketingContacts = state.marketingContacts;
  if (!marketingContacts) return null;

  if (marketingContacts.onRenewal === _RequestStatusTypes.default.FAILED) {
    var isDevPortal = (0, _ScopeSelectors.isDevPortalSelector)(state); // If we weren't able to get contacts, they don't have CRM access, and the can't purchase anyway
    // just show the pricing page with 0 contacts

    if (isDevPortal) {
      return 0;
    }
  }

  return marketingContacts.onRenewal;
};

exports.marketingContactsOnRenewalSelector = marketingContactsOnRenewalSelector;

var hasMarketingContactsWriteScopeSelector = function hasMarketingContactsWriteScopeSelector(state) {
  return (0, _ScopeSelectors.hasScopeSelector)(state, _Scopes.default.MARKETABLE_CONTACTS_WRITE);
};

exports.hasMarketingContactsWriteScopeSelector = hasMarketingContactsWriteScopeSelector;

var shouldShowEligibilityFlowSelector = function shouldShowEligibilityFlowSelector(state) {
  var hasWriteScope = hasMarketingContactsWriteScopeSelector(state);
  var isUngatedForFullLaunch = isUngatedForMCGlobalLaunchSelector(state);
  var isInMCBeta = isInMCBetaSelector(state);

  if (isUngatedForFullLaunch) {
    return hasWriteScope;
  } else {
    return isInMCBeta;
  }
};

exports.shouldShowEligibilityFlowSelector = shouldShowEligibilityFlowSelector;